<template>
  <component
    :is="featureObject?.component"
    v-if="featureObject?.component"
    ref="featureComponent"
    :key="featureObject?.name"
    :title="featureObject?.title[locale]"
    :info="featureObject?.info?.[locale]"
    :children="featureObject?.children"
    :featureName="featureObject?.name"
    v-bind="{ ...$attrs, ...(featureObject.props ?? {}) }"
  />
</template>

<script lang="ts" setup>
import { Feature } from '@/pinia/feature'
import { useFeature } from '@/pinia/features'
import { ComponentPublicInstance, computed, ref, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'

type Props = {
  feature: string | Feature
}

const props = defineProps<Props>()
const { feature: featureName } = toRefs(props)

const { locale } = useI18n()

const { feature } = useFeature(
  typeof featureName.value === 'string' ? featureName.value : undefined
)

const featureComponent = ref<ComponentPublicInstance | null>(null)

const featureObject = computed(
  () => feature.value ?? (typeof featureName.value !== 'string' ? featureName.value : undefined)
)
</script>
